import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";

// Pages
import HomePage from "./pages/HomePage";
import QuizPage from "./pages/QuizPage";
import QuizResultsPage from "./pages/QuizResultsPage";
import FullAssessmentPage from "./pages/FullAssessmentPage";
import FullAssessmentResultsPage from "./pages/FullAssessmentResultsPage";
import BusinessPlanPage from "./pages/BusinessPlanPage";
import CanvasPage from "./pages/CanvasPage";
import CanvasViewPage from "./pages/CanvasViewPage";
import ValidationHubPage from "./pages/ValidationHubPage";
import WaitingListPage from "./pages/WaitingListPage";
import ThankYouPage from "./pages/ThankYouPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelPage from "./pages/PaymentCancelPage";
import ScoreHistoryPage from "./pages/ScoreHistoryPage";
import ActionPlanPage from "./pages/ActionPlanPage";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";

function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id (Google Auth callback)
  // This must be checked synchronously during render, NOT in useEffect
  if (location.hash?.includes('session_id=')) {
    return <AuthCallbackPage />;
  }
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/quiz" element={<QuizPage />} />
          <Route path="/quiz/results/:quizId" element={<QuizResultsPage />} />
          <Route path="/assessment" element={<FullAssessmentPage />} />
          <Route path="/assessment/results/:assessmentId" element={<FullAssessmentResultsPage />} />
          <Route path="/business-plan/:planId" element={<BusinessPlanPage />} />
          <Route path="/canvas" element={<CanvasPage />} />
          <Route path="/canvas/:canvasId" element={<CanvasViewPage />} />
          <Route path="/hub" element={<ValidationHubPage />} />
          <Route path="/waiting-list" element={<WaitingListPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/score-history" element={<ScoreHistoryPage />} />
          <Route path="/action-plan/:planId" element={<ActionPlanPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
